module.exports = __webpack_public_path__ + "01f43047/img/share-action-icon.9c12578c.svg";